export enum EducationMode {
  FullTime,
  External
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/education/education-mode.enum.ts